var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BryntumNumberField',{attrs:{"value":_vm.internalValue,"min":_vm.min,"max":_vm.max,"readOnly":false,"width":_vm.width},on:{"action":function (e) { return _vm.emitValue(e.value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }